import vendorAxiosInstance from "./vendorAxios";

export const sendOtp = async (payload: any) => {
  try {
    return await vendorAxiosInstance.post(`event/vendor/send-otp`, payload);
  } catch (error) {
    throw error;
  }
};

export const verifyOtp = async (payload: any) => {
  try {
    return await vendorAxiosInstance.post(`event/vendor/verify-otp`, payload);
  } catch (error) {
    throw error;
  }
};

export const getVendorInfo = async () => {
  try {
    return await vendorAxiosInstance.get(`event/vendor/vendor-info`);
  } catch (error) {
    throw error;
  }
};

export const updateVendorInfo = async (payload: any) => {
  try {
    return await vendorAxiosInstance.post(`event/vendor/update-info`, payload);
  } catch (error) {
    throw error;
  }
};